import { Cabin, Departure } from '@/data.ts'
import { discountedCabinPrice } from '@/lib/discount.ts'

const DEFAULT_OCCUPANCY = 2

export function calculateCabinPrice (cabin: Cabin, occupancy: number): number {
  if (occupancy < DEFAULT_OCCUPANCY) {
    return cabin.surcharge_price ?? cabin.unit_price
  }
  if (occupancy > DEFAULT_OCCUPANCY) {
    return cabin.discount_price ?? cabin.unit_price
  }
  return cabin.unit_price
}

export function baseCabinPrice (cabin: Cabin): number {
  if (cabin.maximum_occupancy < DEFAULT_OCCUPANCY) {
    return cabin.surcharge_price ?? cabin.unit_price
  }
  if (cabin.minimum_occupancy > DEFAULT_OCCUPANCY) {
    return cabin.discount_price ?? cabin.unit_price
  }
  return cabin.unit_price
}

export function applyDiscount (departure: Departure, price: number): number {
  if (departure.discount == null) {
    return price
  }
  return discountedCabinPrice(price, departure.discount)
}

export function cheapestCabinPrice (departure: Departure): number {
  const prices = departure.cabins.map(cabin => baseCabinPrice(cabin))
  return Math.min(...prices)
}
